import { render, staticRenderFns } from "./AgreementCheckbox.vue?vue&type=template&id=085879b2&scoped=true&"
import script from "./AgreementCheckbox.vue?vue&type=script&lang=js&"
export * from "./AgreementCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AgreementCheckbox.vue?vue&type=style&index=0&id=085879b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085879b2",
  null
  
)

export default component.exports